{
  "nickname": "暱称",
  "nicknameUpdated": "暱称设置成功",
  "nicknameUpdateFailed": "暱称设置失败",
  "nicknameHint": "可使用各语言的字母或数字，不得包含特殊符号，长度不超过30个字符。",
  "save": "保存",
  "changeLoginPassword": "修改登录密码",
  "changeLoginPasswordSuccess": "登录密码修改成功",
  "changeLoginPasswordFailed": "登录密码修改失败",
  "oldPassword": "旧密码",
  "oldPasswordPlaceholder": "请输入旧密码",
  "setTransactionPassword": "设置交易密码",
  "changeTransactionPassword": "修改交易密码",
  "newTransactionPassword": "新交易密码",
  "confirmTransactionPassword": "确认交易密码",
  "transactionPasswordSetSuccess": "交易密码设置成功",
  "transactionPasswordChangedSuccess": "交易密码修改成功",
  "transactionPasswordSetFailed": "交易密码设置失败",
  "transactionPasswordChangedFailed": "交易密码修改失败",
  "transactionPasswordSetFailedWithCode": "交易密码设置失败：{{code}}"
}
